<template>

  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Usuarios inactivos
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right">
            <input
              type="text"
              placeholder="Buscar"
              class="input_solid"
              v-model="options_table.search"
            >
            <img
              src="@/assets/img/icons/search-icon.svg"
              class="button_search"
            >
          </v-flex>
          <div
            class="buttom_reload"
              @click="getClients()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>

      <v-data-table
        v-model="users"
        :headers="options_table.headers_table"
        :items="filteredUsers"
        :search="options_table.search"
        :pagination.sync="options_table.pagination"
        select-all
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th>
              <v-icon>filter_list</v-icon>
            </th>

            <th
              v-for="header in options_table.headers_table"
              :key="header.text"
            >
              <button
                class="faccess_button my-3"
                @click="updateToActive()"
                :disabled="true"
                v-if="header.text == 'Usuario'"
              >
                Habilitar {{ users.length > 0 ? '('+users.length+ ')' : '' }}
              </button>
              <div v-if="options_table.filters.hasOwnProperty(header.value)">
                <v-select v-if="columnValueList(header.value)[0]!=null" flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="options_table.filters[header.value]" :placeholder="header.text">
                </v-select>
              </div>
            </th>
          </tr>
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                color="#1476FB"
                hide-details
                @click.native="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td>
              <v-checkbox
                :input-value="props.selected"
                color="#1476FB"
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-center" width="180px">{{ props.item.rut }}</td>
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center email">{{ props.item.email }}</td>
            <td class="text-xs-center">{{ props.item.mobile }}</td>            
            <td class="text-xs-center" width="250px">{{ props.item.user_type }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>

</template>

<script>
export default {
  data(){
    return{
      selected: 'Todos los usuarios',
      notification_selector: ['Todos los usuarios', 'Varios usuarios'],
      notification: {
        attributes: {
          title: '',
          message: '',
          users: [],
          send_date_time: '',
          gmt: ''
        }
      },
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'N° Documento',
            align: 'center',
            value: 'rut'
          },
          {
            text: 'Usuario',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Email',
            align: 'center',
            value: 'email'
          },

          {
            text: 'Celular',
            align: 'center',
            value: 'mobile'
          },
          {
            text: 'Tipo',
            align: 'center',
            value: 'user_type'
          }
        ],
        filters: {
          gender: [],
          location_name: [],
          age: []
        },
      },

      users: [],
      users_for_select:[],
      right_now: true,
      rules: {
          required: value => !!value || 'Required.',
          title: value => value.length <= 200 || 'Maximo 45 caracteres',
          message: value => value.length <= 250 || 'Maximo 90 caracteres',
      },
      valid: false
    }
  },
  mounted() {
    this.getClients();
  },
  computed: {
    filteredUsers() {
      return this.users_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    }
  },
  methods: {
    toggleAll () {
      var vm = this;
      var emails = document.querySelectorAll("table.v-datatable td.email");
      var check = document.querySelector(".v-table thead [aria-checked]").getAttribute("aria-checked");
      if (check=="false") {
        emails.forEach(function(element) {
          vm.users.splice(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML )),1);
        });
      }else{
        emails.forEach(function(element) {
          if(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML ))==-1){
            vm.users.push(vm.filteredUsers.find( user => user.email === element.innerHTML ));
          }
        });
      }
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    columnValueList(val) {
      return this.users_for_select.map(d => d[val])
    },
    getClients(){
      try {
        console.log('=====this.getCompany().id', this.getCompany().id)
        const data={company:{id:this.getCompany().id}}
        this.$http.post('app/users/clients',{data:this.encrypt(data).toString(),attributes:this.encrypt(data).toString()},{
        //   const data={company:{id:6}}
        // this.$http.post('users/clients',{data:this.encrypt(data).toString()},{
          params:{
            access_state: 'DENIED'
          },
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()}}
         ).then(function(response){
           this.users_for_select = response.body.data;
           if(response.body.meta != undefined && response.body.meta != null){
             if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
               this.checkToken(response.body.meta.authentication_token)
             }
           }
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        };
      }
    },
    updateToActive(){
      try {
        this.$http.patch('access/update_access_state',{
          data: this.encrypt({user_ids: this.users.map(function(x){return x.id}), access_state: "GRANTED"}).toString(),
          attributes: this.encrypt({user_ids: this.users.map(function(x){return x.id}), access_state: "GRANTED"}).toString()
        },{
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
        }).then(function(response){
           if(response.body.meta != undefined && response.body.meta != null){
             if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
               this.checkToken(response.body.meta.authentication_token)
             }
           }
           this.getClients();
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
        if(response.body.meta != undefined && response.body.meta != null){
          if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
            this.checkToken(response.body.meta.authentication_token)
          }
        };
      }
    }


  }

}
</script>



// WEBPACK FOOTER //
// src/components/views/users/Inactive.vue